import { useEffect, useState } from "react";

import { Box, Drawer, Toolbar, Typography } from "@mui/material";
import { makeStyles } from "tss-react/mui";
// import Table from '../../components/Seller/SellerTable';
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import Tab from "@mui/material/Tab";

import { ToastContainer } from "react-toastify";

import _ from "lodash";
import {
	getApprovedWaitlistUser,
	getAwaitedWaitlistUser,
	getInvitedWaitlistUser,
} from "../../apis/waitlist";
import { EditWaitlistStatus } from "../../components/Waitlist/EditWaitlist";
import WaitlistTable from "../../components/Waitlist/WaitlistTable";

const useStyles = makeStyles()((theme) => ({
	title: {
		flexGrow: 1,
		display: "none",
		[theme.breakpoints.up("sm")]: {
			display: "block",
		},
	},
}));

export const Waitlist = () => {
	const { classes } = useStyles();
	const [editOpen, setEditOpen] = useState(false);
	const [, setIsEdit] = useState(false);
	const [, setIsAwaitedEdit] = useState(false);
	const [, setIsInvitedEdit] = useState(false);

	const [rows, setRows] = useState([]);
	const [waitlistUser, setWaitlistUser] = useState();
	const [loading, setLoading] = useState(false);
	const [page, setPage] = useState(0);
	const [rowsCount, setRowsCount] = useState(10);
	const [count, setCount] = useState(0);
	const [awaitedtUser, setAwaitedtUser] = useState();
	const [editAwaitedOpen, setEditAwaitedOpen] = useState(false);
	const [awaitedData, setAwaitedData] = useState([]);

	const [awaitedCount, setAwaitedCount] = useState(0);
	const [invitedtUser, setInvitedtUser] = useState();
	const [editInvitedOpen, setEditInvitedOpen] = useState(false);
	const [invitedData, setInvitedData] = useState([]);

	const [invitedCount, setInvitedCount] = useState(0);

	//   useEffect(() => {
	//     const handleData = async () => {
	//       const data = await getApprovedWaitlistUser();
	//       console.log("TTTTTTTTTTTTTTTTTTTTTTTTTT", data.results);
	//     };
	//     handleData();
	//   }, []);

	const [value, setValue] = useState("1");

	const handleChange = (event, newValue) => {
		setValue(newValue);
	};

	useEffect(() => {
		setLoading(true);
		_.debounce(async () => {
			const data = await getApprovedWaitlistUser(rowsCount);
			setRows(data.results);
			console.log("aaaaaaaaaaaaaaaaaaaaaaaaaa", data);

			setCount(data.count);
		}, 500)();
		setLoading(false);
	}, [rowsCount]);

	const handleEditorClose = async () => {
		setEditOpen(false);
		const data = await getApprovedWaitlistUser(rowsCount, page + 1);

		setRows(data.results);
	};

	// const notify = () =>
	// 	toast.error(`Some unexpected error occured`, {
	// 		position: "bottom-right",
	// 		autoClose: 2500,
	// 		hideProgressBar: false,
	// 		closeOnClick: true,
	// 		pauseOnHover: true,
	// 		draggable: true,
	// 		progress: undefined,
	// 	});

	const handleEdit = (id) => {
		setIsEdit(true);
		setWaitlistUser(rows.find((row) => row.id === id));
		setEditOpen(true);
	};

	const handlePage = async (_, i) => {
		const data = await getApprovedWaitlistUser(rowsCount, i + 1);
		setRows(data.results);
		setPage(i);
	};

	const handleRowsCount = async (i) => {
		setRowsCount(i);
		setLoading(true);
		const data = await getApprovedWaitlistUser(i);
		setRows(data.results);
		setLoading(false);
	};

	//   for awaited user

	useEffect(() => {
		setLoading(true);
		_.debounce(async () => {
			const data = await getAwaitedWaitlistUser(rowsCount);
			setAwaitedData(data.results);
			console.log("awaitedddddddddddddd", data.count);

			setAwaitedCount(data.count);
		}, 500)();
		setLoading(false);
	}, [editAwaitedOpen, rowsCount]);

	const handleAwaitedEditorClose = async () => {
		setEditAwaitedOpen(false);
		const data = await getAwaitedWaitlistUser(rowsCount, page + 1);

		setAwaitedData(data.results);
	};

	const handleAwaitedEdit = (id) => {
		setIsAwaitedEdit(true);
		setAwaitedtUser(awaitedData.find((row) => row.id === id));
		setEditAwaitedOpen(true);
	};

	const handleAwaitedPage = async (_, i) => {
		const data = await getAwaitedWaitlistUser(rowsCount, i + 1);
		setAwaitedData(data.results);
		setPage(i);
	};

	const handleAwaitedRowsCount = async (i) => {
		setRowsCount(i);
		setLoading(true);
		const data = await getAwaitedWaitlistUser(i);
		setAwaitedData(data.results);
		setLoading(false);
	};

	//   for inviteduser

	useEffect(() => {
		setLoading(true);
		_.debounce(async () => {
			const data = await getInvitedWaitlistUser(rowsCount);
			setInvitedData(data.results);
			console.log("invitedddddddddddd", data.count);

			setInvitedCount(data.count);
		}, 500)();
		setLoading(false);
	}, [editInvitedOpen, rowsCount]);

	const handleInvitedEditorClose = async () => {
		setEditInvitedOpen(false);
		const data = await getInvitedWaitlistUser(rowsCount, page + 1);

		setInvitedData(data.results);
	};

	const handleInvitedEdit = (id) => {
		setIsInvitedEdit(true);
		setInvitedtUser(invitedData.find((row) => row.id === id));
		setEditInvitedOpen(true);
	};

	const handleInvitedPage = async (_, i) => {
		const data = await getInvitedWaitlistUser(rowsCount, i + 1);
		setInvitedData(data.results);
		setPage(i);
	};

	const handleInvitedRowsCount = async (i) => {
		setRowsCount(i);
		setLoading(true);
		const data = await getInvitedWaitlistUser(i);
		setInvitedData(data.results);
		setLoading(false);
	};
	return (
		<>
			<Toolbar>
				<Typography className={classes.title} variant="h4" noWrap />
			</Toolbar>
			<ToastContainer />
			<Box sx={{ width: "100%", typography: "body1" }}>
				<TabContext value={value}>
					<Box sx={{ borderBottom: 1, borderColor: "divider" }}>
						<TabList
							onChange={handleChange}
							aria-label="lab API tabs example"
						>
							<Tab label="Awaited" value="1" />
							<Tab label="Invited" value="2" />
							<Tab label="Approved" value="3" />
						</TabList>
					</Box>
					<TabPanel value="1">
						<Box sx={{ px: 5 }}>
							<WaitlistTable
								page={page}
								rowsCount={rowsCount}
								handlePage={handleAwaitedPage}
								handleRowsCount={handleAwaitedRowsCount}
								count={awaitedCount}
								rows={awaitedData}
								loading={loading}
								handleEdit={handleAwaitedEdit}
							/>
							<Drawer
								anchor="right"
								open={editAwaitedOpen}
								onClose={handleAwaitedEditorClose}
							>
								<EditWaitlistStatus
									setEditOpen={setEditAwaitedOpen}
									waitlistUser={awaitedtUser}
									setRows={setAwaitedData}
								/>
							</Drawer>
						</Box>
					</TabPanel>
					<TabPanel value="2">
						<Box sx={{ px: 5 }}>
							<WaitlistTable
								page={page}
								rowsCount={rowsCount}
								handlePage={handleInvitedPage}
								handleRowsCount={handleInvitedRowsCount}
								count={invitedCount}
								rows={invitedData}
								loading={loading}
								handleEdit={handleInvitedEdit}
							/>
							<Drawer
								anchor="right"
								open={editInvitedOpen}
								onClose={handleInvitedEditorClose}
							>
								<EditWaitlistStatus
									setEditOpen={setEditInvitedOpen}
									waitlistUser={invitedtUser}
									setRows={setInvitedData}
								/>
							</Drawer>
						</Box>
					</TabPanel>
					<TabPanel value="3">
						<Box sx={{ px: 5 }}>
							<WaitlistTable
								page={page}
								rowsCount={rowsCount}
								handlePage={handlePage}
								handleRowsCount={handleRowsCount}
								count={count}
								rows={rows}
								loading={loading}
								handleEdit={handleEdit}
							/>
							<Drawer
								anchor="right"
								open={editOpen}
								onClose={handleEditorClose}
							>
								<EditWaitlistStatus
									setEditOpen={setEditOpen}
									waitlistUser={waitlistUser}
									setRows={setRows}
								/>
							</Drawer>
						</Box>
					</TabPanel>
				</TabContext>
			</Box>
		</>
	);
};
